import gql from 'graphql-tag';

const TAG_REQUEST_ASSISTANCE = gql`
  mutation requestAssistance($data: RequestAssistanceInput!) {
    requestAssistance(data: $data)
  }
`;

export default TAG_REQUEST_ASSISTANCE;
